export default async ({ store, redirect, route, app, req }) => {

	if (route.query["sfc-automated-test"]) {
		// return
	}

	if (!store.state.config.userManagementHost) {
		throw "ERROR --> `userManagementHost` is not defined in `app.config.js` (use the example)"
	}

	/*
	* Get requests
	*/

	// SECURE LOGIN REQUESTS
	let url = `${store.state.config.userManagementHost}/securelogins/api/v1/me`
	const params = { access_token: app.$cookies.get('sfc_primary'), app_id: 1, requested_resource: "/" };
	try {
		const response = await app.$httpService.get(url, params)
		if (response.success) {
			store.commit('updateLoginStatus', true)
			store.commit('updateUserEmail', response.content.email)
			store.commit('updateSfcId', response.content.sfc_id)

			// redirect to old subscription page
			if (route.path == '/subscribe') {
				return redirect(`${store.state.config.sfcHost}/subscriptions/signup.php`)
			}
		} else {
			store.commit('updateLoginStatus', false)
			store.commit('updateUserEmail', "")
			store.commit('updateSfcId', "")
		}
	} catch (e) {
		console.log("error", e.message)
		store.commit('updateLoginStatus', false)
	}

	try {
		if (!store.state.menu) {
			let [menu, footer] = await Promise.all([
				app.$httpService.get(store.state.config.s3MenuJsonUrl),
				app.$httpService.get(store.state.config.s3FooterJsonUrl),
			])
			store.commit('updateMenu', menu)
			store.commit('updateFooter', footer)
		}
	} catch (e) {
		store.commit('updateMenu', [{ "name": "529 plans", "url": "/college_savings_201/", "is_pro": false, "menu_link_id": 2, "children": [{ "menu_link_id": 17, "name": "Your State's 529 Plan", "url": "/529_plan_details/", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 215, "name": "529 Able Accounts", "url": "/529-able-accounts/", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 18, "name": "Compare 529 Plans", "url": "/compare-529-plans/", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 19, "name": "5-Cap Ratings", "url": "/5_cap_ratings/", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 152, "name": "Top 10 performance rankings", "url": "https://www.savingforcollege.com/529-plans/performance-rankings", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 217, "name": "529 performance rankings", "url": "/529-performance-rankings", "is_pro": true, "is_direct_child": true }, { "menu_link_id": 20, "name": "Enroll in a 529 plan", "url": "/enroll_in_a_529_plan/", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 22, "name": "Find a 529 Pro", "url": "/find_a_529_pro/", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 216, "name": "529 Plan Investment Options", "url": "/529-plan-investment-options", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 135, "name": "529 fee study", "url": "/529_fee_study/fee_study.php", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 218, "name": "Portfolio fee \u0026 performance lookup", "url": "/portfolio-lookup/", "is_pro": true, "is_direct_child": true }, { "menu_link_id": 162, "name": "529 asset allocation study", "url": "/529-asset-allocation-study/", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 72, "name": "529 news", "url": "/529_news/", "is_pro": false, "is_direct_child": true }] }, { "name": "College Savings 101", "url": "/college_savings_101/", "is_pro": false, "menu_link_id": 1, "children": [{ "menu_link_id": 10, "name": "What is a 529 plan?", "url": "https://www.savingforcollege.com/intro-to-529s/what-is-a-529-plan", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 7, "name": "529 tutorial", "url": "/tutorial101/", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 11, "name": "Coverdell ESA", "url": "/coverdell_esas/", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 74, "name": "For grandparents", "url": "/grandparents/", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 143, "name": "Articles", "url": "/articles/", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 56, "name": "Compare savings options", "url": "/compare-education-savings-options", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 171, "name": "Resources", "url": "/resources/", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 221, "name": "Professional articles", "url": "/articles-professional/", "is_pro": true, "is_direct_child": true }, { "menu_link_id": 220, "name": "Advisor Resources", "url": "/premium-tools/", "is_pro": true, "is_direct_child": true }, { "menu_link_id": 123, "name": "Expert Q\u0026A", "url": "/questions-answers/", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 207, "name": "Legislative Corner", "url": "/529-legislation/", "is_pro": false, "is_direct_child": true }] }, { "name": "Tools \u0026 calculators", "url": "/tools_calculators/", "is_pro": false, "menu_link_id": 144, "children": [{ "menu_link_id": 9, "name": "World's Simplest College Calculator", "url": "https://www.savingforcollege.com/calculators/college-savings-calculator", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 227, "name": "529 Savings Calculator for Private K-12 Tuition", "url": "/calculators/529-private-school-tuition-savings-calculator", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 167, "name": "529 Savings vs. Loans Calculator", "url": "/529-savings-vs-loans-calculator/", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 88, "name": "Is your institution 529 eligible?", "url": "/eligible_institutions/", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 163, "name": "Financial Aid Calculator", "url": "/calculators/financial-aid-calculator/", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 196, "name": "State tax 529 calculator", "url": "/state_tax_529_calculator/", "is_pro": true, "is_direct_child": true }, { "menu_link_id": 197, "name": "The Price of Procrastination Calculator", "url": "/procrastination-calculator/", "is_pro": true, "is_direct_child": true }, { "menu_link_id": 198, "name": "Family College Savings Road Map", "url": "/college-savings-projector/", "is_pro": true, "is_direct_child": true }, { "menu_link_id": 199, "name": "Savings \u0026 Borrowing Funding Tool", "url": "/college-funding-calculator/", "is_pro": true, "is_direct_child": true }, { "menu_link_id": 201, "name": "529 Superfunding Calculator", "url": "/superfunding-calculator/", "is_pro": true, "is_direct_child": true }, { "menu_link_id": 184, "name": "UGMA/UTMA 529 Conversion Calculator", "url": "/ugma-utma-calculator/", "is_pro": true, "is_direct_child": true }, { "menu_link_id": 168, "name": "Licensing Info", "url": "/calculators/", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 223, "name": "PRO 529 Evaluator", "url": "/pro-529-evaluator/", "is_pro": true, "is_direct_child": true }, { "menu_link_id": 225, "name": "Path to College Savings", "url": "/path-to-college/", "is_pro": false, "is_direct_child": true }] }, { "name": "College Planning", "url": "/college-planning/", "is_pro": false, "menu_link_id": 211, "children": [{ "menu_link_id": 226, "name": "Gift Cards", "url": "/gift-of-college/", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 213, "name": "Get College Ready", "url": "/college-planning/", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 113, "name": "Financial aid", "url": "/financial_aid/", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 63, "name": "Scholarships", "url": "/scholarships/", "is_pro": false, "is_direct_child": true }] }, { "name": "Premium tools", "url": "/pro-dashboard", "is_pro": false, "menu_link_id": 129, "children": [{ "menu_link_id": 224, "name": "PRO 529 Evaluator", "url": "/pro-529-evaluator/", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 185, "name": "Professional articles", "url": "/articles-professional/", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 102, "name": "529 performance rankings", "url": "/529-performance-rankings", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 116, "name": "529 composite rankings", "url": "/529-plan-composite-rankings/", "is_pro": false, "is_direct_child": false }, { "menu_link_id": 127, "name": "529 asset allocation category rankings", "url": "/529-asset-allocation-category-rankings/", "is_pro": false, "is_direct_child": false }, { "menu_link_id": 122, "name": "Portfolio fee \u0026 performance lookup", "url": "/portfolio-lookup/", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 44, "name": "Practice building resources", "url": "/practice_building_resources/", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 92, "name": "Subscribe", "url": "/subscriptions/", "is_pro": false, "is_direct_child": true }, { "menu_link_id": 100, "name": "Cancel subscription", "url": "/subscriptions/cancel.php", "is_pro": false, "is_direct_child": true }] }])
	}


	/*
	* Graphql Requests
	*/

	try {

		let ipQuery = ""
		let collegeSavingsUserV2Query = ""
		let savingsCenterQuery = ""
		let stateFromIpQuery = ""

		// Set current IP
		store.dispatch('setIp', req)

		// Generate /savings-center query
		if (route.path.indexOf('/savings-center') != -1 && route.path.indexOf("/savings-center/take-action/find-best-plans") == -1) {
			savingsCenterQuery = `
				college_savings_content_groups{
					name
					contents{
						title
						page{
							title
							slug
						}
					}
				}
				college_savings_user(sfc_token: "${app.$cookies.get('sfc_primary')}", token:"${app.$cookies.get('college_savings_token')}"){
					household_income
					child_age
					quiz_completed
					monthly_contribution
					tax_filing_status_id
					has_a_529_plan
					is_planning_to_open_a_new_529
					highly_rated
					low_fees
					best_performing
					high_maximums
					more_important
					bank_of_america
					email
					state{
						id
						name
						slug
						sfc_id
						number_of_plans
					}
					state_plan{
						id
						state_id
						name
						state_abbreviation
						overall_rating
						plan_details_url
						logo_url
						state_object{
							id
							name
						}
						state_residency_requirements
						has_enroll_now
						enroll_now_url
						enroll_now_count
						rating_designation
						fees_five_star_score
						performance_five_star_score
						one_year_performance_five_star_score
						three_year_performance_five_star_score
						five_year_performance_five_star_score
						ten_year_performance_five_star_score
					}
				}
			`
		}

		if(route.path.indexOf('/savings-center') != -1 && route.path != '/savings-center'){
			collegeSavingsUserV2Query = `
				no_graphql_cache()
				college_savings_user_v2(sfc_token: "${app.$cookies.get('sfc_primary')}", token:"${app.$cookies.get('college_savings_token')}"){
					household_income
				}
			`
		}

		// Get current state from IP
		if(true || !app.$cookies.get('state_from_ip')){
			stateFromIpQuery = `
				no_graphql_cache()
				state_from_ip(click_source:"fetch_state_from_vue"){
					id
					sfc_id
					name
					slug
				}
			`
		}else{
			store.commit('updateStateFromIp', app.$cookies.get('state_from_ip'))
		}
		// Load graphql data
		// Required: user_subscriptions
		// Optional: /savings-center
		// Optional: state_from_ip
		const subscriptionQuery = `
				query{
					no_graphql_cache()
					user_subscriptions(access_token: "${app.$cookies.get('sfc_primary')}", app_id: 1){
						is_gold_member
						is_platinium_member
						is_admin_member
						subscription_order_id
					}
					${savingsCenterQuery}
				}
			`

		if(ipQuery != "" || collegeSavingsUserV2Query != "" || stateFromIpQuery != ""){
			const learnAndIpQuery = `
				query{
					${ipQuery}
					${collegeSavingsUserV2Query}
					${stateFromIpQuery}
				}
			`
			const learnAndIpQueryResponse = await app.$httpService.graphql(learnAndIpQuery)

			if (learnAndIpQueryResponse.data && learnAndIpQueryResponse.data.college_savings_content_groups){
				store.commit('updateSavingsLearnSection', learnAndIpQueryResponse.data.college_savings_content_groups)
			}

			if (learnAndIpQueryResponse.data && learnAndIpQueryResponse.data.state_from_ip) {
				store.commit('updateStateFromIp', learnAndIpQueryResponse.data.state_from_ip)
				app.$cookies.set('state_from_ip', learnAndIpQueryResponse.data.state_from_ip, {
					path: '/',
					domain: 'savingforcollege.com',
					maxAge: 24 * 60 * 60
				})
			}

			// if (learnAndIpQueryResponse.data && learnAndIpQueryResponse.data.college_savings_user) {
			if (learnAndIpQueryResponse.data && learnAndIpQueryResponse.data.college_savings_user_v2) {
				// store.commit('updateSavingsUser', learnAndIpQueryResponse.data.college_savings_user)
				store.commit('updateSavingsUser', learnAndIpQueryResponse.data.college_savings_user_v2)

			} else {
				app.$cookies.remove('college_savings_token')
				store.commit('updateSavingsUser', undefined)
				// if (route.path.indexOf('/savings-center') != -1 && route.path != '/savings-center') {
				// 	return redirect(`/`)
				// }
			}
		}



		const subscriptionResponse = await app.$httpService.graphql(subscriptionQuery)

		if (subscriptionResponse.data && subscriptionResponse.data.user_subscriptions) {
			store.commit('updateSfcSubscriptions', subscriptionResponse.data.user_subscriptions)
		}else{
			store.commit('updateSfcSubscriptions', "")
		}

	} catch (e) {
		console.log("error", e.message)
	}

}
